import { BaseInputFormField } from "./BaseFormField";

export const FileUploadCustomFormFieldMaxFileSize = 1024 * 1024 * 500; 
export const FileUploadCustomFormFieldMaxFileSizeText = '500 MB';
export const FileUploadCustomFormFieldChunkSize = 1024 * 1024 * 6;
export type FileUploadCustomFormFieldBody = {
    uploadSessionId:string,
    fileName:string,
    fileSize:number,
    chunkIndex:number,
    totalChunks:number
}

export type FileUploadCustomFormFieldData = 
{
    uploadSessionId:string,
    videoId:string,
    fileName:string,
    fileSize:number,
    started:Date
    status: 
    {
        stage:'uploading',
        lastChunkIndex:number,
        totalChunks:number
    } |
    {
        stage:'complete',
        thumbnailUrl:string,
        playerUrl:string
    } |
    {
        stage:'error'
    }
}

export type FileUploadCustomFormField = BaseInputFormField & {

    type:'FileUpload'
}